import React, { useMemo, useState, useEffect } from 'react';
import { Modal, Card, Col, Row, Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postOrgEmployee, getOrgEmployeeDetails, postOrgEmployeeSave, deleteOrgEmployeeDelete, getOrgEmployeeContactPerson } from '../../apiservices/ApiServices';
import DateFild from '../../components/DateTimePicker/DateFild';
import { FaCloudUploadAlt } from "react-icons/fa";

const Employee = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [empData, setEmpData] = useState([]);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [contactPersionOptions, setContactPersionOptions] = useState([]);

    const postOrgEmployees = async (postData) => {
        setLoading(true);
        try {
            const res = await postOrgEmployee(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                employeeId: item?.employee_id,
                employeeCode: item?.employee_code,
                employeeDOB: item?.employee_dob,
                employeeDOJ: item?.employee_doj,
                employeeIsActive: item?.is_active,
                employeeWorkLocation: item?.work_location || 'N/A',
                is_user_profile: item?.is_user_profile ? 1 : 0,
                orgName: item?.org_organization.org_name,
                orgNameId: item?.org_organization.org_id,

                contactPersion: `${item?.org_contact_person?.first_name} ${item?.org_contact_person?.last_name}`,
                contactPersionId: item?.org_contact_person?.contact_person_id || 'N/A',
                email: item?.org_contact_person?.email || 'N/A',
                mobile: item?.org_contact_person?.mobile_number || 'N/A',
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateEmployee = async () => {
        let postData = {
            "search": "",
            "filters": {
                "org_organization.org_name": "",
                "employee_code": "",
                "employee_dob": ""
            },
            "page": 1,
            "length": 100
        }
        try {
            const res = await postOrgEmployee(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                employeeId: item?.employee_id,
                employeeCode: item?.employee_code,
                employeeDOB: item?.employee_dob,
                employeeDOJ: item?.employee_doj,
                employeeIsActive: item?.is_active,
                employeeWorkLocation: item?.work_location || 'N/A',
                is_user_profile: item?.is_user_profile ? 1 : 0,
                orgName: item?.org_organization.org_name,
                orgNameId: item?.org_organization.org_id,

                contactPersion: `${item?.org_contact_person?.first_name} ${item?.org_contact_person?.last_name}`,
                contactPersionId: item?.org_contact_person?.contact_person_id || 'N/A',
                email: item?.org_contact_person?.email || 'N/A',
                mobile: item?.org_contact_person?.mobile_number || 'N/A',
            }));
            setData(formattedData);
        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            "search": "",
            "filters": {
                "org_organization.org_name": "",
                "employee_code": "",
                "employee_dob": ""
            },
            "page": 1,
            "length": 100
        }
        postOrgEmployees(postData);
    }, []);

    const initialValues = {
        id: '',
        empCode: '',
        orgId: '',
        contactPersonId: '',
        employeeDob: '',
        employeeDoj: '',
        employeeDol: '',
        workLocation: '',
        panNumber: '',
        panFile: '',
        aadharNumber: '',
        aadharFile: '',
        employeeImage: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            const formData = new FormData();
            if (isEdit) {
                formData.append('employee_id', values.id);
            }
            formData.append('org_id', values.orgId);
            formData.append('contact_person_id', values.contactPersonId);
            formData.append('employee_dob', values.employeeDob || '');
            formData.append('employee_doj', values.employeeDoj || '');
            formData.append('employee_dol', values.employeeDol || '');
            formData.append('work_location', values.workLocation || '');
            formData.append('pan_number', values.panNumber);
            formData.append('pan_file', values.panFile);
            formData.append('aadhar_number', values.aadharNumber);
            formData.append('aadhar_file', values.aadharFile);
            formData.append('employee_image', values.employeeImage);

            try {
                const res = await postOrgEmployeeSave(formData);
                toast.success(res.data.message);
                setLoadings(false);
                postUpdateEmployee();
                setIsEdit(false);
                setAddModal(false);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        try {
            const res = await getOrgEmployeeContactPerson();
            setEmpData(res.data.data);
            setLoadings(false);
            setAddModal(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "emp. Code",
                accessor: "employeeCode",
            },
            {
                Header: "Org. Name",
                accessor: "orgName",
            },
            {
                Header: "Contact persion",
                accessor: "contactPersion",
            },
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Mobile",
                accessor: "mobile",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['userswitch', 'edit', 'delete']


    const fetchFileFromUrl = async (url, fileName) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const file = new File([blob], fileName,
                {
                    type: blob.type || 'image/jpeg'
                });

            return file;
        } catch (error) {
            console.error('Error fetching file:', error);
            return null;
        }
    };

    const handleEdit = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        try {
            const res = await getOrgEmployeeContactPerson();
            setEmpData(res.data.data);

            try {
                const res = await getOrgEmployeeDetails(rowData.employeeId);

                setFieldValue('id', res.data.data?.employee_id || '');
                setFieldValue('orgId', res.data.data?.org_organization?.org_id || '');
                setFieldValue('contactPersonId', res.data.data?.org_contact_person?.contact_person_id || '');
                setFieldValue('employeeDob', res.data.data?.employee_dob || '');
                setFieldValue('employeeDoj', res.data.data?.employee_doj || '');
                setFieldValue('employeeDol', res.data.data?.employee_dol || '');
                setFieldValue('workLocation', res.data.data?.work_location || '');
                setFieldValue('panNumber', res.data.data?.pan_number || '');
                setFieldValue('aadharNumber', res.data.data?.aadhar_number || '');

                if (res.data.data?.pan_file && res.data.data?.pan_file_name) {

                    const file = await fetchFileFromUrl(
                        res.data.data?.pan_file,
                        res.data.data?.pan_file_name
                    );
                    if (file) {
                        setFieldValue('panFile', file);
                    }
                }

                if (res.data.data?.aadhar_file && res.data.data?.aadhar_file_name) {

                    const file = await fetchFileFromUrl(
                        res.data.data?.aadhar_file,
                        res.data.data?.aadhar_file_name
                    );
                    if (file) {
                        setFieldValue('aadharFile', file);
                    }
                }

                if (res.data.data?.employee_image && res.data.data?.employee_image_name) {

                    const file = await fetchFileFromUrl(
                        res.data.data?.employee_image,
                        res.data.data?.employee_image_name
                    );
                    if (file) {
                        setFieldValue('employeeImage', file);
                    }
                }


                setIsEdit(true);
                setAddModal(true);
                setLoadings(false);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }




    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('empCode', rowData.employeeCode);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteOrgEmployeeDelete(values.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateEmployee();
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    const handleConfirm = () => {
        setAddModal(false);
        formik.resetForm();
    };

    useEffect(() => {
        if (values.orgId) {
            const selectedOption = empData.find(orgList => orgList.org_id == values.orgId);

            if (selectedOption && selectedOption.contact_persons && selectedOption.contact_persons.length > 0) {
                //console.log('asdasd', selectedOption.contact_persons)
                setContactPersionOptions(selectedOption.contact_persons);
            } else {
                setContactPersionOptions([]);
            }
        } else {
            setContactPersionOptions([]);
        }
    }, [values.orgId]);

    const handleSwitchToggle = (rowData) => {
        setData(prev => prev.map(item =>
            item.employeeId === rowData.employeeId
                ? {
                    ...item,
                    is_user_profile: item.is_user_profile === 1 ? 0 : 1
                }
                : item
        ));
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Employee" active="Employee" items={['Employee', 'Org Module']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Employee</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => addnew()}
                                                    >
                                                        Add New
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                        onSwitchToggle={handleSwitchToggle}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modal
                show={addModal}
                size={'xl'}
                centered={true}
                backdrop={true}
            >
                <div className="modal-header">
                    <div className="modal-title h4" style={{ color: "#000" }}>Add new</div>
                    <button onClick={() => { setAddModal(false); }} type="button" className="btn-close" aria-label="Close"></button>
                </div>
                <Modal.Body>
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className='cols_5'>
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select Organization</label>
                                        <SelectFild
                                            Firstop='Select Organization'
                                            selectName="orgId"
                                            options={empData}
                                            value={values.orgId}
                                            onChange={(selectedOption) => setFieldValue("orgId", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.orgId && touched.orgId && (
                                            <p className="errormsg">{errors.orgId}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select Employee</label>
                                        <SelectFild
                                            Firstop='Select Employee'
                                            selectName="contactPersonId"
                                            options={contactPersionOptions}
                                            value={values.contactPersonId}
                                            onChange={(selectedOption) => setFieldValue("contactPersonId", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.contactPersonId && touched.contactPersonId && (
                                            <p className="errormsg">{errors.contactPersonId}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Date of Birth</label>
                                        <DateFild
                                            value={values.employeeDob}
                                            onChange={(date) => setFieldValue('employeeDob', date)}
                                        />
                                        {errors.employeeDob && touched.employeeDob && (
                                            <p className="errormsg">{errors.employeeDob}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Date of Joining</label>
                                        <DateFild
                                            value={values.employeeDoj}
                                            onChange={(date) => setFieldValue('employeeDoj', date)}
                                        />
                                        {errors.employeeDoj && touched.employeeDoj && (
                                            <p className="errormsg">{errors.employeeDoj}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Date of Leave </label>
                                        <DateFild
                                            value={values.employeeDol}
                                            onChange={(date) => setFieldValue('employeeDol', date)}
                                        />
                                        {errors.employeeDol && touched.employeeDol && (
                                            <p className="errormsg">{errors.employeeDol}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Pan Number</label>
                                        <input
                                            type='text'
                                            id="panNumber"
                                            name="panNumber"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.panNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.panNumber && touched.panNumber && (
                                            <p className="errormsg">{errors.panNumber}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Upload Pan File</label>
                                        <div className='fileuploadbox'>
                                            <p className='filename'>{values?.panFile.name}</p>
                                            <div className='uploadbtn'>
                                                <FaCloudUploadAlt />
                                            </div>
                                            <input
                                                type='file'
                                                id="panFile"
                                                name="panFile"
                                                autoComplete='off'
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                onChange={(event) => {
                                                    const file = event.currentTarget.files[0];
                                                    setFieldValue('panFile', file);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        {errors.panFile && touched.panFile && (
                                            <p className="errormsg">{errors.panFile}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Aadhar Number</label>
                                        <input
                                            type='text'
                                            id="aadharNumber"
                                            name="aadharNumber"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.aadharNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.aadharNumber && touched.aadharNumber && (
                                            <p className="errormsg">{errors.aadharNumber}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Upload Aadhar File</label>
                                        <div className='fileuploadbox'>
                                            <p className='filename'>{values?.aadharFile.name}</p>
                                            <div className='uploadbtn'>
                                                <FaCloudUploadAlt />
                                            </div>
                                            <input
                                                type='file'
                                                id="aadharFile"
                                                name="aadharFile"
                                                autoComplete='off'
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                onChange={(event) => {
                                                    const file = event.currentTarget.files[0];
                                                    setFieldValue('aadharFile', file);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                        </div>

                                        {errors.aadharFile && touched.aadharFile && (
                                            <p className="errormsg">{errors.aadharFile}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Employee Image</label>
                                        <div className='fileuploadbox'>
                                            <p className='filename'>{values?.employeeImage.name}</p>
                                            <div className='uploadbtn'>
                                                <FaCloudUploadAlt />
                                            </div>
                                            <input
                                                type='file'
                                                id="employeeImage"
                                                name="employeeImage"
                                                autoComplete='off'
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                onChange={(event) => {
                                                    const file = event.currentTarget.files[0];
                                                    setFieldValue('employeeImage', file);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                        </div>

                                        {errors.employeeImage && touched.employeeImage && (
                                            <p className="errormsg">{errors.employeeImage}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Work Location</label>
                                        <input
                                            type='text'
                                            id="workLocation"
                                            name="workLocation"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.workLocation}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.workLocation && touched.workLocation && (
                                            <p className="errormsg">{errors.workLocation}</p>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className='modalfooters'>
                            <div className='button-boxs grid'>
                                <button type='submit' className='btn btn-primary'>{isEdit ? 'Update' : 'Submit'}</button>
                                <button type='button' onClick={handleConfirm} className='btn btn-default'>Closed</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to <span>{values.empCode}</span> Delete Employee ?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default Employee